import { useConfigurationStore } from '../../stores/useConfigurationStore';

export function buildValidationMapFromStore(): Array<{ key: string; value: string }> {
  const { menuConfiguration, connectorBindingConfiguration } =
    useConfigurationStore.getState();

  return [
    { key: 'SKEY', value: menuConfiguration.sKeyValue || '' },
    { key: 'OBJECT-TYPE', value: menuConfiguration.objectTypeValue || '' },
    { key: 'END-POINT_1', value: connectorBindingConfiguration.endpoint1Value.value || '' },
    { key: 'END-POINT_2', value: connectorBindingConfiguration.endpoint2Value.value || '' },
    { key: 'END-POINT_3', value: connectorBindingConfiguration.endpoint3Value.value || '' },
    { key: 'END-POINT_4', value: connectorBindingConfiguration.endpoint4Value.value || '' },
  ].filter((entry) => entry.value.trim() !== '');
}
